// Bank, kjørebok og Altinn (no).
window.PlummeI18n.register('no', {
  'bank.analysis.running': 'Analyserer …',
  'bank.analysis.completed': 'Analysert av SuperPlumma',
  'bank.analysis.start': 'Start analyse',
  'bank.analysis.retry': 'Prøv analysen på nytt',
  'bank.periodImport.dropFile': 'Slipp bankfilen her',
  'bank.periodImport.missingMonth': 'Mangler bankutskrift for {{period}}',
  'bank.periodImport.monthUploadHelp': 'Last opp CSV, PDF eller XLSX for {{account}}. Filen kan dekke én eller flere måneder, uansett hvilken måned du står i. Banklinjene fordeles automatisk på riktig måned etter dato. Du kan også supplere tidligere import med en ny kontoutskrift.',
  'bank.periodImport.title': 'Last opp bankfil',
  'bank.periodImport.help': 'Last opp transaksjoner eller kontoutskrift for én eller flere måneder. Opplastingen er uavhengig av måneden du har valgt.',
  'bank.periodImport.chooseAccount': 'Velg bankkonto',
  'bank.periodImport.coverageHelp': 'Kontroller eksportens periode. Første og siste transaksjonsdato er bare et forslag; dager uten transaksjoner kan også være med.',
  'bank.periodImport.from': 'Eksport fra og med',
  'bank.periodImport.to': 'Eksport til og med',
  'bank.periodImport.confirmCoverage': 'Filen inneholder alle bankbevegelser i denne perioden, uten søke- eller beløpsfilter.',
  'bank.periodImport.closing': 'Utgående banksaldo (UB)',
  'bank.periodImport.balanceHelp': 'Saldoene er valgfrie ved import. Bruk bankens bokførte saldo rett før startdato og ved slutten av sluttdatoen. La feltet stå tomt hvis saldoen er ukjent. En senere kontoutskrift kan supplere med IB/UB.',
  'bank.periodImport.preview': 'Kontroller import',
  'bank.periodImport.save': 'Importer bankfil',
  'bank.periodImport.continue': 'Fortsett der jeg var',
  'bank.periodImport.process': 'Behandle hele perioden',
  'bank.periodImport.result': '{{added}} nye transaksjoner · {{matched}} gjenkjent',
  'bank.periodImport.preserved': 'Tidligere behandling, føringer og bilagskoblinger er bevart.',
  'bank.periodImport.fileMissing': 'Transaksjonene er lagret, men originalfilen kunne ikke lagres. Last opp filen igjen for å bevare dokumentasjonen.',
  'bank.periodImport.monthLines': '{{count}} linjer',
  'bank.periodImport.balanceFound': 'UB registrert',
  'bank.periodImport.balanceMissing': 'Banksaldo mangler',
  'bank.periodImport.chooseMatch': 'Velg eksisterende transaksjon med annen tekst',
  'bank.periodImport.newTransaction': 'Dette er en egen, ny transaksjon',
  'bank.periodImport.worklist': 'Bank · samlet arbeidsliste',
  'bank.periodImport.worklistHelp': 'Behandle linjene fortløpende på tvers av månedene. Hver måned har fortsatt egen saldokontroll og avstemming.',
  'bank.periodImport.needBalances': 'Banksaldo mangler. Du kan behandle linjene nå og supplere med kontoutskrift eller dokumentert IB/UB før avstemming.',
  'bank.periodImport.partial': 'Dette er en delvis måned. Behandle linjene nå og suppler resten av måneden før den ferdigstilles.',
  'bank.periodImport.files': 'Importerte originalfiler',
  'bank.periodImport.openPeriods': 'Åpne importerte perioder',
  'bank.control.ledgerDifference': '{{month}}: Bokført UB {{booked}}, bankens UB {{bank}}. Avvik {{difference}}. Måneden må kontrolleres på nytt.',
  'bank.control.openingLedgerDifference': '{{month}}: Bankens IB {{bank}}, IB i hovedboken {{booked}}. Avvik {{difference}}. Registrer en balansert inngående balanse under Regnskap før avstemmingen ferdigstilles.',
  'bank.control.ledgerMismatchTitle': 'Avvik mot hovedboken',
  'bank.archiveLedgerMismatch': 'Kan ikke arkivere: bokført saldo per {{date}} er {{booked}} kr, mens bankens saldo er {{bank}} kr. Avvik {{difference}} kr.',
  'bank.statementDiscrepancy': 'Utskriftsavvik',
  'bank.balanceDiscrepancy': 'Saldoavvik',
  'bank.balanceDiscrepancyHelp': 'Forskjellen mellom bokført saldo og bankens utgående saldo.',
  'bank.removedLineCannotBook': 'En feilavlest banklinje som er fjernet fra avstemmingen kan ikke bokføres.',
  'bank.control.missingBalance': '{{month}}: Bankutskriften mangler UB. Bokført UB er {{booked}}. Saldoene er ikke kontrollert mot hverandre.',
  'bank.control.ready': 'Utskriftene dekker perioden og er avstemt.',
  'bank.control.openingSetupMissing': '{{account}} mangler bekreftet oppstartsdato eller banksaldo. Gå til Innstillinger → Bank og bekreft bankens startsaldo mot IB. Ikke legg inn IB på nytt. Oppgi 0 bare hvis kontoutskriften viser nullsaldo.',
  'bank.control.needsReview': 'Bankkontrollen har ufullstendig oppstartsgrunnlag, manglende utskrifter, uavstemte perioder, saldoavvik eller posteringer før startsaldo.',
  'bank.control.missing': 'Mangler bankutskrifter for {{year}}: {{months}}.',
  'bank.control.unsettled': 'Utskrifter er lastet opp, men ikke ferdig avstemt for {{year}}: {{months}}.',
  'bank.control.existingBeforeStart': '{{count}} postering(er) er datert før startsaldo {{date}}. Kontroller posteringene og startsaldoen i bankinnstillingene. Startsaldoen endres ikke automatisk av tidligere posteringer.',
  'bank.control.postingBeforeStart': 'Posteringen er datert før startsaldoen for bankkonto {{account}} ({{date}}). Kontroller dato og startsaldo i bankinnstillingene før du bokfører.',

  'bank.patternBased': 'Basert på tidligere mønster',
  'bank.patternTitle': 'Tidligere mønster',
  'bank.patternExplanation': 'Plumme foreslår denne behandlingen fordi lignende banklinjer tidligere er ført likt. Forslaget må fortsatt godkjennes. Du kan stoppe mønsteret uten å endre tidligere føringer.',
  'bank.patternVariableAmounts': 'Plumme husker type og konto, men gjenbruker ikke tidligere avdrag, renter eller gebyr. Beløpene må kontrolleres mot dokumentasjonen hver gang.',
  'bank.patternStop': 'Ikke bruk mønsteret',
  'bank.patternStopped': 'Mønsteret er stoppet',
  'bank.patternStopFailed': 'Kunne ikke stoppe mønsteret.',
  'bank.backToYearClosing': 'Tilbake til årsavslutning',
  // ------------------------------- Bank, kjorebok, Altinn (misc.jsx)
  'bank.editEntry': 'Rediger føring',
  'bank.bankLine': 'Banklinje',
  'bank.saveAndPost': 'Lagre og bokfør',
  'bank.readFrom': 'Informasjon er lest av fra',
  'bank.voucherType': 'Bilagstype',
  'bank.purchaseVoucher': 'Kjøpsbilag',
  'bank.salesVoucher': 'Salgsbilag',
  'bank.counterparty': 'Motpart',
  'bank.supplierOrParty': 'Leverandør / motpart',
  'bank.businessAccount': 'Bedriftskonto',
  'bank.paidPrivately': 'Privat betalt',
  'bank.uploadOrForward': 'Last opp eller videresend bilag på e-post — vi leser av det vi kan.',
  'bank.uploadedReceived': 'Lastet opp/mottatt',
  'bank.searchVouchers': 'Søk i bilag — filnavn, PDF, bilde…',
  'bank.noInboxVouchers': 'Ingen bilag i innboksen ennå',
  'bank.noInboxVouchersHelp': 'Last opp et bilag eller videresend leverandørfakturaer til bilagsadressen.',
  'bank.allMonths': 'Alle måneder',
  'bank.uploading': 'Laster opp …',
  'bank.uploadingCount': 'Laster opp {{done}}/{{total}} …',
  'bank.analyzingCount': 'Analyserer {{done}}/{{total}} …',
  'bank.dragToReorder': 'Dra for å endre rekkefølge',
  'bank.editTheEntry': 'Rediger føringen',
  'bank.moveToTrash': 'Flytt til søppelkassen',
  'bank.dropFilesHere': 'Slipp filene her',
  'bank.weReadWhatWeCan': 'Vi leser av det vi kan',
  'bank.deleteForeverTitle': 'Slette for godt?',
  'bank.deleteForever': 'Ja, slett permanent',
  'km.time': 'Tid',
  'km.avgSpeed': 'Snittfart',
  'km.useDistance': 'Bruk distanse',
  'km.searching': 'Søker...',
  'km.from': 'Fra',
  'km.to': 'Til',
  'km.resolvingAddress': 'Finner adresse...',
  'km.gpsGapTitle': 'Hull i GPS-sporet',
  'km.gpsGap': 'Sporingen mistet posisjonen underveis, og {km} km er ikke tatt med. Kontroller kilometeren før du lagrer turen.',
  'km.sub': 'Registrer kjøreturer og hold oversikt over kjøregodtgjørelsen.',
  'km.newTripOrLog': 'Ny tur / Kjørebok',
  'km.newTripOrLogHelp': '«Ny tur» registrerer en ny kjøretur. «Kjørebok» viser oversikten over alle turene du har ført, med samlet distanse og fradrag.',
  'km.tripDetails': 'Detaljer for turen',
  'km.tripDetailsHelp': 'Fyll inn opplysningene som dokumenterer kjøreturen: dato, formål (hvorfor du kjørte), fra- og til-sted, og antall kilometer. Formålet er viktig — turen må være yrkesrelatert for å gi fradrag.',
  'km.purposePh': 'F.eks. kundemøte hos Lunde & Vik',
  'km.purposeQuickPicks': 'Hurtigvalg',
  'km.returnTrip': 'Tur/retur',
  'km.returnTripHelp': 'Kryss av når du kjørte samme vei tilbake. Kilometerne og fradraget dobles, og turen dokumenteres som tur/retur i kjøreboken.',
  'km.returnTripRow': 'Tur/retur',
  'km.perLeg': 'Én vei',
  'km.removeStop': 'Fjern stopp',
  'km.addStop': 'Legg til stopp',
  'km.addStopHelp': 'Legg til et stoppested mellom start og destinasjon — nyttig når turen går innom flere steder. Hvert stopp blir en del av ruten som dokumenteres.',
  'km.calcAuto': 'Beregn km automatisk',
  'km.calcAutoHelp': 'Regner ut antall kilometer mellom fra, stopp og til-sted automatisk ved hjelp av kart, så du slipper å slå opp avstanden selv.',
  'km.ratePerKm': 'Sats per km',
  'km.ratePerKmHelp': 'Statens sats for kjøregodtgjørelse per kilometer. Plumme bruker den gjeldende satsen automatisk til å regne ut fradraget.',
  'km.registeredDistance': 'Registrert distanse',
  'km.registeredDistanceHelp': 'Antall kilometer du har lagt inn for denne turen.',
  'km.deductionAmount': 'Fradragsbeløp',
  'km.deductionAmountHelp': 'Kilometer ganget med satsen — det skattefrie beløpet du kan få i kjøregodtgjørelse for turen.',
  'km.saveHelp': 'Lagrer kjøreturen i kjøreboken. Den teller med i årets samlede distanse og fradrag, og kan dokumenteres ved en eventuell kontroll.',
  'km.drivenThisYear': 'Kjørt i år',
  'km.drivenThisYearHelp': 'Samlet antall kilometer yrkeskjøring du har registrert hittil i år.',
  'km.deductionThisYear': 'Fratrekk i år',
  'km.deductionThisYearHelp': 'Samlet kjøregodtgjørelse (fradrag) for årets registrerte turer.',
  'km.searchPh': 'Søk på rute, formål eller dato',
  'km.deleteTripTitle': 'Slette kjøretur?',
  'km.deleteTripConfirm': 'Ja, slett',
  'bank.alreadyPostedToOperating': 'Allerede bokført mot driftskonto',
  'bank.openInJournal': 'Åpne i bilagsjournal',
  'bank.noEntriesInView': 'Ingen poster i denne visningen.',
  'bank.fixUp': 'Korriger',
  'bank.pickLine': 'Velg linje',
  'bank.noFreeLines': 'Ingen ledige banklinjer i denne utskriften.',
  'bank.link': 'Koble',
  'bank.statement': 'Bankutskrift',
  'bank.openOriginal': 'Åpne original',
  'bank.downloadCsv': 'Last ned CSV',
  'bank.openingBalance': 'Inngående saldo',
  'bank.originalNotDownloadable': 'Originalfilen kan ikke lastes ned.',
  'bank.viewUsesImported': 'Visningen under bruker banklinjene som allerede er importert.',
  'bank.balance': 'Saldo',
  'bank.noImportedLines': 'Ingen importerte banklinjer i denne utskriften.',
  'bank.importNoTransactions': 'Fant ingen transaksjoner i «{{fileName}}», men saldoene viser en bevegelse på {{difference}}. Kontroller linjene mot originalen før du avstemmer. Utskriften ble ikke lagret.',
  'bank.importBalanceMismatch': 'Avlesningen stemmer ikke med saldoene i utskriften: {{difference}} i differanse. Kontroller linjene mot originalen før du avstemmer. Utskriften ble ikke lagret.',
  'bank.importUnreadablePeriod': 'Kunne ikke lese perioden i bankutskriften. Utskriften ble ikke lagret.',
  'bank.imageAnalysisUnavailable': 'Bildeanalyse av bankutskrifter er ikke tilgjengelig ennå.',
  'bank.importFailed': 'Kunne ikke lese bankutskriften.',
  'bank.readingStatement': 'Leser utskriften…',
  'bank.openStatementPreview': 'Åpne forhåndsvisning av bankutskriften',
  'bank.seeOriginal': 'Se utskrift',
  'bank.almostDone': 'Nesten i mål',
  'bank.linesRemaining': 'linjer gjenstår å behandle',
  'bank.discrepancy': 'Avvik',
  'bank.discrepancyHelp': 'Beregnet avvik mellom saldo og banklinjer',
  'bank.openingBalanceHelp': 'Saldoen på bankkontoen ved starten av perioden — hentet fra forrige avstemming.',
  'bank.closingBalanceHelp': 'Saldoen på bankkontoen ved slutten av perioden, ifølge bankutskriften. Den skal stemme med bokført saldo etter at alle linjer er behandlet.',
  'bank.useSuperPlumma': 'Bruk SuperPlumma',
  'bank.useSuperPlummaHelp': 'Lar SuperPlumma finne forslag til kontroll. Du godkjenner resultatet før bokføring.',
  'bank.reconcileAndPost': 'Avstem og bokfør',
  'bank.chronologicalTitle': 'En tidligere periode er ikke avstemt',
  'bank.chronologicalBody': 'Avstem {{period}} først. Inngående saldo hentes fra forrige utskrift, så et avvik der ville blitt usynlig her.',
  'bank.reconcileAndPostHelp': 'Bokfører banklinjene, låser perioden når alle linjer er behandlet og flytter utskriften til arkivet.',
  'bank.reconcileAndArchive': 'Avstem og arkiver',
  'bank.reconcileAndArchiveHelp': 'Bokfører banklinjene, låser perioden når alle linjer er behandlet og flytter utskriften til arkivet.',
  'bank.existingEntryMatch.action': 'Match bokført post',
  'bank.existingEntryMatch.title': 'Match bokført post',
  'bank.existingEntryMatch.help': 'Velg posten som allerede fører samme bankbeløp. Det opprettes ingen ny bokføring.',
  'bank.existingEntryMatch.dateMismatch': 'Datoen avviker med {days} dager. Kontroller posten før du kobler.',
  'bank.existingEntryMatch.none': 'Ingen bokførte poster med samme beløp og nærliggende dato ble funnet.',
  'bank.existingEntryMatch.success': 'Banklinjen er koblet til den bokførte posten.',
  'bank.existingEntryMatch.error': 'Kunne ikke koble banklinjen.',
  'bank.reopenAndReverse': 'Åpne og reverser',
  'bank.reopenAndReverseHelp': 'Åpner den avstemte bankutskriften igjen slik at bokføringen kan rettes. Perioden låses opp.',
  'bank.settledTitle': 'Avstemt og bokført',
  'bank.settledOn': 'Arkivert {{date}}',
  'bank.settledHelp': 'Utskriften ligger i arkivet.',
  'bank.settledBadge': 'Avstemt',
  'bank.alreadySettled': 'Bankutskriften er allerede avstemt og arkivert. Åpne den igjen hvis noe må rettes.',
  'bank.postedToOperating': 'Bokført mot driftskonto',
  'bank.postedToOperatingHelp': 'Disse føringene er bokført på driftskontoen for denne bankperioden.',
  'bank.linkVoucher': 'Koble',
  'bank.openLinkedVoucher': 'Åpne {{name}}',
  'bank.openingBalanceImported': 'Avlest fra utskriften: {{amount}}',
  'bank.useExpectedOpening': 'Sett inngående saldo til {{amount}}',
  'bank.receiptLinked': 'Koblet til banklinje',
  'bank.duplicateUpload': 'Mulig dobbeltopplasting',
  'bank.ambiguousMatch': 'Flere like bilag — velg selv hvilket som hører til',
  'bank.linkSuggestedVouchers': 'Koble {{count}} foreslåtte bilag',
  'bank.searchLines': 'Søk i banklinjer…',
  'bank.addLine': 'Legg til banklinje',
  'bank.noLinesInView': 'Ingen banklinjer i denne visningen.',
  'bank.missingVoucher': 'Mangler bilag',
  'bank.missingVoucherAction': 'Mangler bilag · klikk eller dra hit',
  'bank.missingVoucherHelp': 'Dra et bilag fra innboksen hit for å koble det. Hvis bilaget er mistet eller ikke kan skaffes, kan du klikke og registrere det som borte.',
  'bank.markVoucherLostTitle': 'Marker bilag som borte',
  'bank.markVoucherLostHelp': 'Bokføringen beholdes, men dette erstatter ikke dokumentasjon. Oppfølgingen lukkes og valget lagres på banklinjen med begrunnelse, tidspunkt og bruker.',
  'bank.markVoucherLostConfirm': 'Registrer',
  'bank.markVoucherLostSaving': 'Registrerer …',
  'bank.voucherLostReason': 'Forklaring',
  'bank.voucherLostReasonHint': 'Påkrevd. Forklar hvorfor bilaget ikke kan skaffes.',
  'bank.voucherLostReasonPlaceholder': 'F.eks. kvitteringen er mistet, og leverandøren kan ikke sende kopi.',
  'bank.voucherLostReasonRequired': 'Skriv kort hvorfor bilaget ikke kan skaffes.',
  'bank.voucherLostError': 'Kunne ikke markere bilaget som borte.',
  'bank.voucherLostUnavailable': 'Markering av bilag borte er ikke koblet til backend.',
  'bank.docReason.lostText': 'Bilaget er borte og kan ikke fremskaffes.',
  'bank.docReason.never': 'Aldri mottatt',
  'bank.docReason.neverText': 'Leverandøren har ikke sendt kvittering eller faktura.',
  'bank.docReason.statementOnly': 'Kun i bankutskriften',
  'bank.docReason.statementOnlyText': 'Transaksjonen står bare i bankutskriften, og eget bilag finnes ikke.',
  'bank.docReason.notApplicable': 'Ikke aktuelt',
  'bank.docReason.notApplicableText': 'Eget bilag er ikke aktuelt for denne føringen.',
  'bank.voucherMarkedLost': 'Bilag borte',
  'bank.voucherMarkedLostToast': 'Bilaget er merket som borte',
  'bank.sendVoucherBack': 'Send bilaget tilbake til innboksen',
  'bank.approveSuggestion': 'Godkjenn forslag',
  'bank.approveSuggestionHelp': 'Godtar SuperPlummas forslag til kontering for linjen og bokfører den slik.',
  'bank.review': 'Kontroller',
  'bank.markPrivate': 'Marker privat',
  'bank.post': 'Bokfør',
  'bank.reviewEntries': 'Kontroller poster',
  'bank.previewUnavailable': 'Forhåndsvisning er ikke tilgjengelig',
  'bank.previewUnavailableHelp': 'Bilaget mangler en tilgjengelig filadresse.',
  'bank.noVatCalculated': 'Ingen MVA beregnes. Hele bankbeløpet på',
  'bank.amountExVatBecomes': 'Beløpet eks. MVA blir',
  'bank.actualAmountIncVat': 'Faktisk bankbeløp inkl. MVA blir',
  'bank.saveAndClose': 'Lagre og lukk',
  'bank.manualLine': 'Manuell banklinje',
  'bank.amountExInc': 'Bankbeløp eks./inkl. MVA',
  'bank.amountExIncHelp': 'Trykk for å bytte om beløpet vises med eller uten MVA. Plumme regner automatisk om, mens faktisk beløp fra banktransaksjonen fortsatt lagres inkl. MVA.',
  'bank.costAccount': 'Kostnadskonto',
  'bank.accountCategory': 'Konto/kategori',
  'bank.salesAccount': 'Salgskonto',
  'bank.pickOpenInvoice': 'Velg åpen faktura',
  'bank.noMatchingInvoices': 'Ingen åpne fakturaer matcher dette beløpet.',
  'bank.matchesVatPeriod': 'Matcher valgt MVA-termin. Bokføring og betalt-markering skjer når terminen kobles.',
  'bank.mixedUseManual': 'Hvis linjen blander MVA, skatt, korreksjoner eller andre justeringer, bruk fri postering.',
  'bank.matchesPayrollPeriod': 'Matcher valgt forskuddstrekk/AGA-termin. Velg hvilken del banklinjen faktisk betaler.',
  'bank.payrollPeriod': 'Forskuddstrekk / AGA-termin',
  'bank.whatIsPaymentFor': 'Hva gjelder betalingen?',
  'bank.payrollAccountsHelp': 'Forskuddstrekk er 2600, arbeidsgiveravgift er 2770.',
  'bank.feeHelp': 'Bruk denne for bank- og kortgebyrer. Beløpet bokføres uten MVA mot',
  'bank.noFeeAccount': 'Ingen egnet gebyrkonto finnes i kontoplanen.',
  'bank.roundingHelp': 'Bruk bare dette for en reell liten avrundingsforskjell. Beløpet bokføres uten MVA mot',
  'bank.swapFromTo': 'Bytt fra og til',
  'bank.pickTwoAccounts': 'Velg to ulike kontoer før du lagrer den frie posteringen.',
  'bank.manualPostingBankMismatch': 'Summen på bankkontoen i posteringen må være lik banklinjen.',
  'bank.supplierVatHelp': 'MVA-satsen på leverandørfakturaen. Inngående MVA beregnes fra beløpet.',
  'bank.supplierDueDateHelp': 'Forfallsdatoen på leverandørens faktura. Dekker banklinjen bare en del av beløpet, er resten fortsatt en åpen post — og fristen er den aldersfordelingen regnes fra.',
  'bank.supplierInvoiceGross': 'Fakturaens totalbeløp',
  'set.bank.currency': 'Valuta',
  'set.bank.accountNumberHelp': 'Kontonummeret slik banken oppgir det. Punktum og mellomrom fjernes automatisk — regnskapet, importfilene og betalingene sammenligner sifrene, og et nummer med skilletegn matcher ikke sin egen kontoutskrift.',
  'set.bank.currencyName.NOK': 'Norske kroner',
  'set.bank.currencyName.SEK': 'Svenske kroner',
  'set.bank.currencyName.DKK': 'Danske kroner',
  'set.bank.currencyName.EUR': 'Euro',
  'set.bank.currencyName.USD': 'Amerikanske dollar',
  'set.bank.currencyName.GBP': 'Britiske pund',
  'set.bank.currencyName.CHF': 'Sveitsiske franc',
  'set.bank.currencyName.ISK': 'Islandske kroner',
  'set.bank.currencyName.PLN': 'Polske zloty',
  'set.bank.currencyName.CZK': 'Tsjekkiske koruna',
  'set.bank.currencyName.JPY': 'Japanske yen',
  'set.bank.currencyName.CAD': 'Kanadiske dollar',
  'set.bank.currencyName.AUD': 'Australske dollar',
  'set.loans.title': 'Låneregister',
  'set.loans.sub': 'Lån og langsiktig gjeld med nedbetalingsplan',
  'set.loans.help': 'Et lån er ellers bare en hovedbokskonto. Saldoen sier hva som står igjen, men ikke hvor mye som forfaller det neste året — og uten det kan ikke kortsiktig og langsiktig gjeld skilles. Avdragene bokføres som før, gjennom bank eller bilag.',
  'set.loans.none': 'Ingen lån registrert.',
  'set.loans.add': 'Legg til lån',
  'set.loans.remove': 'Slett lån',
  'set.loans.lender': 'Långiver',
  'set.loans.ledgerAccount': 'Hovedbokskonto',
  'set.loans.ledgerAccountHelp': 'Kontoen lånet står på. Uten den kan lånet ikke avstemmes mot regnskapet.',
  'set.loans.missingAccount': 'Mangler konto',
  'set.loans.originalAmount': 'Opprinnelig lånebeløp',
  'set.loans.interestRate': 'Rente (%)',
  'set.loans.startDate': 'Startdato',
  'set.loans.repaymentType': 'Nedbetalingstype',
  'set.loans.termsPerYear': 'Terminer per år',
  'set.loans.monthly': 'Månedlig (12)',
  'set.loans.quarterly': 'Kvartalsvis (4)',
  'set.loans.halfYearly': 'Halvårlig (2)',
  'set.loans.yearly': 'Årlig (1)',
  'set.loans.installmentAmount': 'Terminbeløp',
  'set.loans.installmentHelp': 'Avdraget per termin for serielån, hele terminbeløpet for annuitetslån.',
  'set.loans.remainingTerms': 'Gjenstående terminer',
  'set.loans.interestOnlyUntil': 'Avdragsfri til',
  'set.loans.interestOnlyHelp': 'La stå tomt hvis lånet ikke har avdragsfrihet.',
  'set.loans.security': 'Pant og sikkerhet',
  'set.loans.planIncomplete': 'Planen er ikke komplett nok til å regne ut hva som forfaller det neste året. Avstemmingen sier fra i stedet for å gjette.',
  'set.loans.planSays': 'Planen sier {amount} forfaller de neste tolv månedene. Klassifiseringen kortsiktig/langsiktig er fortsatt en faglig vurdering.',
  'set.bank.currencyHelp': 'Kontoens egen valuta. NOK for vanlige norske kontoer. En konto i annen valuta avstemmes ved omregning til balansedagens kurs, ikke ved direkte sammenligning.',
  'bank.supplierInvoiceGrossHelp': 'Fyll bare ut hvis banklinjen dekker en del av fakturaen. Da registreres fakturaen med sitt fulle beløp, og det banklinjen betaler føres som en delbetaling — resten blir stående som utestående på leverandøren.',
  'bank.shortDescriptionPh': 'Kort beskrivelse av transaksjonen…',
  'bank.previewVoucher': 'Forhåndsvis bilaget',
  'bank.noVoucherUploaded': 'Ingen bilag lastet opp',
  'bank.fetchFromInbox': 'Hent fra Innboks',
  'bank.backToBank': 'Tilbake til bank',
  'bank.privateBank': 'Privat bank',
  'bank.privateBankHelp': 'Privatkontoen brukes som et ryddeverktøy: gå gjennom linjene, marker de som egentlig er firmautgifter som «Drift» (de bokføres da på driftskontoen), og ignorer de rent private. Slik får du med firmakostnader du har lagt ut for privat.',
  'bank.finishReview': 'Fullfør gjennomgang',
  'bank.finishReviewHelp': 'Bokfører linjene du har markert som drift på driftskontoen, og arkiverer den ferdig gjennomgåtte privatutskriften.',
  'bank.dragVoucherFromInbox': 'Dra bilag fra innboksen',
  'bank.toOperations': 'Til driften',
  'bank.toOperationsHelp': 'Åpner bokføringsvalgene for linjen, slik at konto, MVA, bilag og type blir riktig før den flyttes til driften.',
  'bank.ignore': 'Ignorer',
  'bank.ignoreHelp': 'Marker linjen som rent privat og hold den utenfor firmaregnskapet. Trykk igjen for å angre.',
  'bank.voucherReceivedOn': 'Bilag mottatt på',
  'bank.superPlummaFetches': 'SuperPlumma henter og kobler',
  'bank.searchInbox': 'Søk i innboksen...',
  'bank.reopen': 'Åpne igjen',
  'bank.viewPostings': 'Se posteringer',
  'bank.waitingPrevious': 'Venter på forrige',
  'bank.waitingPreviousHelp': 'Du kan åpne og kontrollere utskriften nå, men den kan ikke bokføres eller avstemmes før den forrige utskriften er ferdig.',
  'bank.previousMustReconcile': 'Forrige bankutskrift må avstemmes først. Du kan kontrollere denne utskriften, men ikke bokføre eller avstemme den ennå.',
  'bank.openStatement': 'Åpne bankutskrift',
  'bank.deleteStatement': 'Slett utskrift',
  'bank.deleteStatementTitle': 'Slett bankutskrift?',
  'bank.deleteStatementConfirm': '{{fileName}} fjernes permanent. Bokførte føringer og bilag slettes ikke, men mister koblingen til utskriften. De står uten bankavstemming til du laster opp en utskrift for perioden — da matches de automatisk, eller vises som avvik. Dette kan ikke angres.',
  'bank.statementFallback': 'Bankutskriften',
  'bank.deleteUnavailable': 'Sletting av bankutskrift er ikke tilgjengelig ennå.',
  'bank.deleteSuccess': 'Bankutskriften er slettet',
  'bank.deleteReopenFirst': 'Åpne bankutskriften igjen før den slettes.',
  'bank.deleteNewerFirst': 'Nyere bankutskrifter må slettes først. Behandlede bankutskrifter slettes fra nyeste til eldste.',
  'bank.deleteError': 'Kunne ikke slette bankutskriften.',
  'bank.deleteSettledBlocked': 'Avstemte eller bokførte bankutskrifter kan ikke slettes.',
  'bank.deleteReverseFirst': 'Bokføringen må reverseres før bankutskriften kan slettes.',
  'bank.deleteMatchGroupBlocked': 'Bankutskriften inngår i en bokført matchinggruppe. Reverser gruppen før utskriften slettes.',
  'bank.deleteMatchGroupOffline': 'Bankutskriften inngår i en matchinggruppe. Prøv igjen når du er tilkoblet.',
  'bank.noArchivedStatements': 'Ingen arkiverte bankutskrifter ennå.',
  'bank.archivedHelp': 'Ferdig avstemte perioder havner her når alle linjer er behandlet og arkivert.',
  'bank.uploadFile': 'Last opp fil',
  'bank.opPrivArchive': 'Drift / Privat / Arkiv',
  'bank.opPrivArchiveHelp': '«Drift» avstemmer firmaets driftskonto. «Privat» brukes til å rydde i en privatkonto og flytte firmarelaterte linjer over til driften. «Arkiv» viser ferdig avstemte utskrifter.',
  'bank.privateNotLinked': 'Privatkonto er personlig og knyttes ikke til firmabankkonto.',
  'bank.bankAccount': 'Bankkonto',
  'bank.bankAccountHelp': 'Velg hvilken bankkonto du avstemmer. Hver konto har sitt eget kontonummer i kontoplanen (f.eks. 1920 driftskonto, 1950 skattetrekkskonto) og sine egne utskrifter.',
  'bank.noAccountsSetUp': 'Ingen bankkontoer er satt opp',
  'bank.noStatements': 'Ingen bankutskrifter ennå.',
  'bank.noStatementsHelp': 'Last opp en bankfil for valgt konto, eller kontroller at riktig foretak er valgt.',
  'bank.connectBank': 'Koble til banken',
  'bank.connectBankHelp': 'Koble Plumme direkte til banken din via sikker Open Banking. Da hentes transaksjonene automatisk og SuperPlumma bokfører og avstemmer fortløpende — så du slipper å laste opp utskrifter manuelt.',
  'bank.connectYourBank': 'Koble til banken din',
  'bank.connect': 'Koble til',
  'altinn.sub': 'Send skjemaer videre til det offentlige — vi fyller ut det vi kan på forhånd.',
  'altinn.filingVia': 'Innsending via Altinn',
  'altinn.open': 'Åpne Altinn',
  'altinn.openHelp': 'Åpner Altinn-portalen i en ny fane, der du logger inn med din ID og fullfører innsendingen av de forhåndsutfylte skjemaene.',
  'altinn.formsAndStatus': 'Skjemaer og status',
  'altinn.formsAndStatusHelp': 'Oversikt over de offentlige skjemaene foretaket skal levere, med RF-referansenummer og status. Statusen viser om skjemaet er levert, forfaller snart, eller ikke levert ennå.',
  'altinn.form': 'Skjema',
  'altinn.formHelp': 'Navnet på det offentlige skjemaet. RF-nummeret i neste kolonne er Skatteetatens offisielle referanse for skjemaet.',
  'altinn.statusHelp': '«Levert» er sendt inn, «Forfaller snart» nærmer seg frist, og «Ikke levert» gjenstår å sende.',
  'setl.sub': 'Firma, faktura, bank og varsler - alt på ett sted.',
  'setl.companyInfo': 'Firmaopplysninger',
  'setl.companyName': 'Firmanavn',
  'setl.invoiceSettings': 'Fakturainnstillinger',
  'setl.nextInvoiceNo': 'Neste fakturanummer',
  'setl.defaultPaymentTerms': 'Standard betalingsfrist',
  'setl.defaultVatRate': 'Standard MVA-sats',
  'setl.reminderFee': 'Purregebyr',
  'setl.sendCopyToMe': 'Send kopi til meg',
  'setl.sendCopyHelp': 'Få en kopi av hver faktura på e-post.',
  'setl.bankAndAccount': 'Bank og konto',
  'setl.mainLedgerAccount': 'Hovedkonto i regnskap',
  'setl.notifications': 'Varsler',
  'km.pageHelp': 'Kjøreboken dokumenterer yrkeskjøring og privat bruk av næringsbil. Næringsturer gir kjøregodtgjørelse etter statens sats, mens privat kjøring loggføres uten fradrag.',
  'km.newTrip': 'Ny tur',
  'km.tripType': 'Turtype',
  'km.typeBusiness': 'Næring',
  'km.typePrivate': 'Privat',
  'km.privateUse': 'Privat bruk',
  'km.privatePurposePh': 'Privat bruk (valgfritt)',
  'km.privateNote': 'Privat kjøring loggføres, men gir ikke fradrag og blir ikke bokført.',
  'km.ownCar': 'Egen bil',
  'km.startPlace': 'Startsted',
  'km.stopN': 'Stopp {n}',
  'km.stopPh': 'Adresse underveis',
  'km.destination': 'Destinasjon',
  'km.calculating': 'Beregner...',
  'km.saveChanges': 'Lagre endringer',
  'km.saveEntry': 'Lagre kjørebokføring',
  'km.privateDriving': 'Privat kjøring',
  'km.privateDrivingHelp': 'Privat bruk er dokumentert i kjøreboken, men gir ikke fradrag.',
  'km.filterType': 'Type',
  'km.tryOtherSearch': 'Prøv et annet søk eller nullstill filteret.',
  'km.distance': 'Distanse',
  'km.stops': 'Stopp',
  'km.returnYes': 'Ja ({km} km hver vei)',
  'km.returnNo': 'Nei',
  'km.status': 'Status',
  'km.statusLogged': 'Loggført',
  'km.statusPosted': 'Bokført',
  'km.route': 'Rute',
  'km.amount': 'Beløp',
  'km.deleteTripBody': 'Er du sikker på at du vil slette denne kjøreturen{route}? Denne handlingen kan ikke reverseres.',
  'km.speedUnit': 'km/t',
  'km.gps.unavailable': 'GPS er ikke tilgjengelig i denne nettleseren.',
  'km.gps.denied': 'GPS-tilgang ble avvist eller kunne ikke startes.',
  'km.gps.active': 'GPS aktiv',
  'km.gps.inactive': 'GPS er ikke aktiv',
  'km.gps.stop': 'Stopp tur',
  'km.gps.start': 'Start tur',
  'km.gps.done': 'Tur fullført',
  'km.gps.tracking': 'Sporer posisjonen din.',
  'km.gps.doneHint': '{km} km registrert. Bruk distansen i skjemaet under.',
  'km.gps.startHint': 'Start turen for å aktivere GPS-sporing.',
  'km.toast.editTrip': 'Rediger kjøretur - endre og lagre på nytt',
  'km.toast.openedNotFound': 'Åpnet kjøreboken. Fant ikke nøyaktig kjøretur å redigere automatisk.',
  'km.toast.fillFromTo': 'Fyll ut minst fra- og til-adresse først.',
  'km.toast.calcUnavailable': 'Automatisk km-beregning er ikke tilgjengelig enda.',
  'km.toast.distanceFailed': 'Kunne ikke beregne avstand.',
  'km.toast.kmCalculated': 'Kilometer beregnet automatisk',
  'km.toast.calcFailed': 'Kunne ikke beregne kilometer automatisk.',
  'km.toast.fillPrivate': 'Fyll ut dato, fra, til og kilometer før du lagrer privat kjøring.',
  'km.toast.fillBusiness': 'Fyll ut dato, fra, til, formål og kilometer før du lagrer.',
  'km.toast.updated': 'Kjøreturen er oppdatert',
  'km.toast.saved': 'Kjøreturen er lagret',
  'km.toast.deleted': 'Kjøretur slettet',
  'bank.filter.all': 'Alle',
  'bank.filter.processing': 'Til behandling',
  'bank.filter.suggestion': 'Forslag klart',
  'bank.filter.control': 'Trenger kontroll',
  'bank.filter.missing': 'Mangler bilag',
  'bank.filter.deviation': 'Mulig avvik',
  'bank.filter.done': 'Ferdig',
  'bank.typeGroup.sales': 'Salg',
  'bank.typeGroup.purchase': 'Kjøp',
  'bank.typeGroup.other': 'Annet',
  'bank.typeGroup.tax': 'Skatt og avgifter',
  'bank.typeGroup.loan': 'Lån og gjeld',
  'bank.type.invoicePayment': 'Fakturabetaling',
  'bank.type.otherSales': 'Annet salg',
  'bank.type.payOpenSupplier': 'Leverandørfaktura: betal åpen',
  'bank.type.newSupplier': 'Leverandørfaktura: registrer ny',
  'bank.type.purchase': 'Vanlig kjøp',
  'bank.type.free': 'Fri postering',
  'bank.type.fee': 'Gebyr',
  'bank.type.rounding': 'Ørediff / øreavrunding',
  'bank.type.owner': 'Privat uttak / innskudd',
  'bank.type.vat': 'MVA-betaling',
  'bank.type.payroll': 'Forskuddstrekk / AGA',
  'bank.type.tax': 'Skattebetaling',
  'bank.type.loan': 'Lån / gjeld',
  'bank.agaPart.withholding': 'Forskuddstrekk mot 2600',
  'bank.agaPart.employer': 'Arbeidsgiveravgift mot 2770',
  'bank.agaPart.both': 'Begge samlet, fordelt på 2600 og 2770',
  'bank.vat.none': 'Ingen MVA',
  'bank.vat.input': '{{code}} - Inngående MVA {{rate}} %',
  'bank.accountFallback': 'Konto {{code}}',
  'bank.countsAsZero': '{{note}} · teller som 0,00 kr i avstemmingen',
  'bank.csv.date': 'Dato',
  'bank.csv.description': 'Beskrivelse',
  'bank.csv.note': 'Notat',
  'bank.csv.amount': 'Beløp',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Bokført {{amount}}',
  'bank.posted': 'Bokført',
  'bank.posted.vatAmount': 'MVA {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'MVA {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Velg leverandørfakturaen som betalingen gjelder.',
  'bank.err.supplierPaymentMustBeOutgoing': 'Betaling av leverandørfaktura må være en utbetaling fra bank.',
  'bank.err.supplierPaymentUnavailable': 'Betaling av leverandørfaktura fra bank er ikke tilgjengelig ennå.',
  'bank.deviation.intro': 'Disse postene er bokført mot bankkontoen, men Plumme finner ikke en trygg banklinje som forklarer dem.',
  'bank.deviation.none': 'Ingen mulige avvik i denne perioden.',
  'bank.detail.date': 'Dato',
  'bank.detail.amount': 'Beløp',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'Post-ID',
  'bank.detail.type': 'Type',
  'bank.detail.period': 'Periode',
  'bank.detail.noReceipt': 'Ingen bilag er koblet til posteringen',
  'bank.detail.receiptPreviewable': 'Bilaget kan forhåndsvises direkte her.',
  'bank.detail.noPreview': 'Det finnes ikke et bilag å forhåndsvise.',
  'bank.toast.postingCorrected': 'Den bokførte posteringen er korrigert',
  'bank.toast.postingVoided': 'Posteringen er annullert. Eventuelt bilag ligger tilbake i innboksen.',
  'bank.transition.review': 'Kontroller overgangen fra importert regnskap før denne utskriften bokføres.',
  'bank.transition.fixOpening': '{{message}} Rett inngående saldo før du bokfører.',
  'bank.toast.voucherLinkedName': 'Bilag koblet: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma har ingen bilagsforslag å koble.',
  'bank.toast.oneVoucherLinked': 'Ett bilag er koblet',
  'bank.toast.nVouchersLinked': '{{count}} bilag er koblet',
  'bank.toast.linkSuggestedFailed': 'Kunne ikke koble de foreslåtte bilagene.',
  'bank.toast.linkedToPosted': 'Banklinjen er koblet til den allerede bokførte posten',
  'bank.toast.linkToPostedFailed': 'Kunne ikke koble banklinjen til den bokførte posten.',
  'bank.toast.saveCustomerFirst': 'Lagre kunden før linjen godkjennes.',
  'bank.toast.saveSupplierFirst': 'Lagre eller velg leverandøren før linjen godkjennes.',
  'bank.toast.reviewSuggestionFirst': 'Kontroller forslaget i banklinjen før du godkjenner.',
  'bank.toast.invoicePaymentDone': 'Fakturabetalingen er bokført og banklinjen er ferdig',
  'bank.toast.supplierPaymentDone': 'Leverandørfakturaen er betalt og banklinjen er ferdig',
  'bank.toast.enterSupplierName': 'Legg inn leverandørnavn før fakturaen godkjennes.',
  'bank.toast.enterInvoiceNumber': 'Legg inn fakturanummer før fakturaen godkjennes.',
  'bank.toast.checkCostAccount': 'Kontroller kostnadskontoen før fakturaen godkjennes.',
  'bank.toast.supplierInvoiceDone': 'Leverandørfakturaen er bokført og banklinjen er ferdig',
  'bank.toast.suggestionDone': 'Forslaget er bokført og banklinjen er ferdig',
  'bank.toast.alreadyDone': 'Banklinjen er allerede bokført og ferdig',
  'bank.toast.suggestionNotApproved': 'Forslaget kunne ikke godkjennes.',
  'bank.toast.suggestionNeedsReview': 'Forslaget må kontrolleres før godkjenning.',
  'bank.approve': 'Godkjenn',
  'bank.toast.pickUnprocessed': 'Velg minst én ubehandlet banklinje.',
  'bank.toast.approveLineFailed': 'Kunne ikke godkjenne banklinjen.',
  'bank.toast.nLinesApproved': '{{count}} linjer godkjent',
  'bank.toast.lineAdded': 'Banklinje lagt til',
  'bank.toast.lineLinkUnavailable': 'Kobling av banklinje er ikke tilgjengelig ennå.',
  'bank.toast.linkedToExistingPosted': 'Banklinjen er koblet mot eksisterende bokført post',
  'bank.controlPosting.title': 'Bokført bankpost',
  'bank.controlPosting.sub': 'Mulig avvik: bokført på bankkontoen, men ikke funnet i bankutskriften.',
  'bank.toast.openedAsDeviation': 'Banklinjen er åpnet som avvik',
  'bank.toast.investmentMatchReopened': 'Bankkoblingen til investeringen er frigjort',
  'bank.toast.balanceCorrectionUnavailable': 'Saldokorrigering er ikke tilgjengelig ennå.',
  'bank.toast.openingMustBeNumber': 'Inngående saldo må være et tall.',
  'bank.toast.openingUpdated': 'Inngående saldo oppdatert',
  'bank.toast.openingFromImport': 'Inngående saldo satt fra importovergangen',
  'bank.toast.closingMustBeNumber': 'Utgående saldo må være et tall.',
  'bank.toast.closingUpdated': 'Utgående saldo oppdatert',
  'bank.toast.roundingMustBeNumber': 'Ørediff må være et tall.',
  'bank.toast.roundingCorrected': 'Ørediff korrigert',
  'bank.mark.posted': 'Bokført',
  'bank.mark.alreadyPosted': 'Allerede bokført',
  'bank.mark.approved': 'Godkjent',
  'bank.mark.needsReview': 'Trenger kontroll',
  'bank.mark.deviation': 'Mulig avvik',
  'bank.mark.suggestion': 'Forslag klart',
  'bank.mark.private': 'Privat',
  'bank.mark.removed': 'Fjernet',
  'bank.mark.new': 'Ikke behandlet',
  'bank.toast.analysisUnavailable': 'SuperPlumma-analyse er ikke tilgjengelig ennå.',
  'bank.toast.foundSuggestions': 'SuperPlumma fant {{count}} forslag til kontroll',
  'bank.toast.noSafeSuggestions': 'SuperPlumma fant ingen sikre forslag',
  'bank.toast.analysisFailed': 'SuperPlumma kunne ikke analysere banklinjene.',
  'bank.toast.alreadyArchived': 'Bankutskriften er allerede avstemt og arkivert.',
  'bank.toast.reconciledArchived': 'Bankutskriften er avstemt og arkivert.',
  'bank.toast.reopenFailed': 'Kunne ikke gjenåpne avstemmingen.',
  'bank.matchMultiple': 'Match flere',
  'bank.transition.title': 'Kontroller overgangen fra importert regnskap',
  'bank.transition.changeAnchor': 'Endre «Avstemt til og med» og startsaldo i Innstillinger hvis importankeret ble satt feil.',
  'bank.previousNotReconciled': 'Tidligere periode er ikke avstemt',
  'bank.correctViaPencil': 'Korriger via blyantikonet',
  'bank.correctReadBalance': 'Korriger avlest saldo',
  'bank.analysis.alreadyDone': 'Bankutskriften er allerede analysert. Ny analyse er sperret for å unngå unødvendig tokenbruk.',
  'bank.analysis.autoRunning': 'SuperPlumma analyserer bankutskriften automatisk.',
  'bank.analysis.analyzedShort': 'Analysert av SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma analyserer',
  'bank.archiveBlocked.chronological': 'Avstem {{name}} først. Avstemming må gjøres kronologisk, fordi inngående saldo hentes fra forrige utskrift.',
  'bank.archiveBlocked.deviation': 'Saldoavvik må være 0,00 kr før bankutskriften kan arkiveres.',
  'bank.archiveBlocked.lines': 'Alle banklinjer må behandles før bankutskriften kan arkiveres.',
  'bank.reviewAndApprove': 'Kontroller og godkjenn',
  'bank.voucherN': 'Bilag {{n}}',
  'bank.voucherLinked': 'Bilag koblet',
  'bank.showVoucher': 'Vis bilag',
  'bank.voucherSuggested': 'Bilag foreslått',
  'bank.voucherMissingBadge': 'Bilag mangler',
  'bank.toast.linkRemoved': 'Koblingen er fjernet. Bilaget ligger i innboksen.',
  'bank.sendVouchersBack': 'Send bilagene tilbake til innboksen',
  'bank.toast.vouchersSentBack': 'Bilagene er sendt tilbake til innboksen',
  'bank.analysisHint.tap': 'La SuperPlumma analysere linjene og foreslå bokføring, eller trykk på et bilag og deretter på banklinjen for å koble.',
  'bank.analysisHint.drag': 'La SuperPlumma analysere linjene og foreslå bokføring, eller dra et bilag rett på banklinjen for å koble.',
  'bank.showInbox': 'Vis innboks',
  'bank.toast.lineDone': 'Banklinjen er bokført og ferdig',
  'bank.toast.noInboxVouchers': 'Ingen bilag i innboksen å koble.',
  'bank.toast.balanceCorrected': 'Saldoen er korrigert',
  'bank.toast.misreadRemoved': 'Feilavlest linje er tatt ut av avstemmingen',
  'bank.toast.readingCorrected': 'Avlesningen er korrigert',
  'bank.toast.postedFixed': 'Den bokførte posten er rettet',
  'bank.toast.lineRemoved': 'Banklinjen er fjernet fra avstemmingen',
  'bank.vatTerm.jun': 'MVA {{year}} - 10. juni',
  'bank.vatTerm.apr': 'MVA {{year}} - 10. april',
  'bank.vatTerm.feb': 'MVA {{year}} - 10. februar',
  'bank.vatTerm.aug': 'MVA {{year}} - 31. august',
  'bank.vatTerm.oct': 'MVA {{year}} - 10. oktober',
  'bank.vatTerm.dec': 'MVA {{year}} - 10. desember',
  'bank.agaTerm': 'Lønnsskatt/AGA {{n}}. termin {{year}}',
  'bank.ownerAccountFallback': 'Privat-/eierkonto',
  'bank.periodHint': 'Bankutskriften gjelder {{from}} - {{to}}.',
  'bank.voucher': 'Bilag',
  'bank.ownerType.withdrawal': 'Privat uttak',
  'bank.ownerType.deposit': 'Privat innskudd',
  'bank.ownerType.both': 'Privat uttak / innskudd',
  'bank.ownerType.owner': 'Eier / mellomregning',
  'bank.vat86.prefix': 'Leverandørbeløpet',
  'bank.vat86.suffix': 'er grunnlaget. Kode 86 beregner både utgående og inngående MVA med 25 % uten å redusere bankbeløpet.',
  'bank.postedWithoutVat': 'bokføres uten MVA.',
  'bank.withVatRate': 'med {{rate}} % MVA.',
  'bank.amountHelp.locked': 'Beløpet er hentet fra bankutskriften og kan ikke endres.',
  'bank.amountHelp.unlocked': 'Posteringen er ikke koblet til en banklinje, så beløpet kan rettes her. Endringen lagres i revisjonssporet.',
  'bank.amountHelp.mustMatch': 'Beløpet må stemme med den faktiske banktransaksjonen.',
  'bank.err.enterAmount': 'Legg inn bankbeløp før du lagrer linjen.',
  'bank.err.dateWithinStatement': 'Datoen må være innenfor bankutskriften: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Velg to ulike kontoer før du lagrer fri postering.',
  'bank.err.enterSupplierName': 'Legg inn leverandørnavn før du lagrer leverandørfaktura.',
  'bank.err.enterInvoiceNumber': 'Legg inn fakturanummer før du bokfører leverandørfakturaen.',
  'bank.err.invoicePaymentIncoming': 'Fakturabetaling må være en innbetaling fra banken.',
  'bank.err.pickInvoice': 'Velg faktura før du lagrer fakturabetalingen.',
  'bank.err.pickOwnerAccount': 'Velg privat-/eierkonto før du godkjenner føringen.',
  'bank.err.pickLoanAccount': 'Velg låne-/gjeldskonto eller bruk fri postering.',
  'bank.err.loanSplitSum': 'Avdrag, renter og gebyr må summere til bankbeløpet.',
  'bank.err.supplierPaymentOutgoing': 'Betaling av leverandørfaktura må være en utbetaling fra banken.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Velg leverandørfaktura før du lagrer betalingen.',
  'bank.err.correctionReason': 'Skriv kort hvorfor posteringen korrigeres.',
  'bank.err.noReceiptReason': 'Legg inn en kort begrunnelse for hvorfor eget bilag ikke er nødvendig.',
  'bank.err.linkVoucherOrWaive': 'Koble bilag, eller huk av for at separat dokumentasjon ikke finnes eller ikke er nødvendig.',
  'bank.err.uploadUnavailable': 'Bilagsopplasting er ikke tilgjengelig ennå.',
  'bank.err.analysisFailedAfterUpload': 'Bilaget ble lastet opp, men analysen feilet.',
  'bank.toast.uploadedAndLinked': 'Bilag lastet opp og koblet til banklinjen.',
  'bank.toast.linkOnSaveCorrection': 'Bilaget blir koblet når du lagrer korrigeringen.',
  'bank.toast.linkOnSaveLine': 'Bilaget blir koblet når du lagrer banklinjen.',
  'bank.err.uploadFailed': 'Kunne ikke laste opp bilag.',
  'bank.modal.correctPosting': 'Korriger postering',
  'bank.modal.editLine': 'Rediger banklinje',
  'bank.modal.saveCorrection': 'Lagre korrigering',
  'bank.modal.approveAndClose': 'Godkjenn og lukk',
  'bank.modal.fieldsLocked': 'Bankbeløp, dato, type og bankkobling er låst. Konto, MVA og intern beskrivelse kan korrigeres med revisjonsspor.',
  'bank.modal.correctionUnlocked': 'Posteringen er ikke koblet til en banklinje i bankutskriften. Dato, beløp, konto, MVA, bilag og intern beskrivelse kan korrigeres med revisjonsspor. Er selve posteringstypen feil, må posteringen annulleres og føres på nytt.',
  'bank.modal.manualLineHelp': 'Bruk dette bare når en faktisk banktransaksjon mangler i utskriften, for eksempel ved importfeil eller en banklinje som må føres manuelt før avstemming.',
  'bank.help.sales': 'Salg bruker standard salgskonto og MVA-oppsett. Senere kobles dette mot faktura/KID når det finnes.',
  'bank.help.ownerSole': '{{label}} bokføres mellom bank og valgt privatkonto uten inntekt, kostnad eller MVA.',
  'bank.help.ownerUnknownEntity': 'Foretaksform er ikke satt i innstillingene, så Plumme foreslår ingen konto her. Velg motkonto selv, eller sett foretaksform for å få forslag.',
  'bank.help.ownerIntercompany': 'Dette er en eier-/mellomregningsføring, ikke en privat ENK-føring. Velg dokumentert motkonto; lån, utbytte og kapitalinnskudd må behandles i riktig fagflyt.',
  'bank.label.privateAccount': 'Privatkonto',
  'bank.label.ownerAccount': 'Eier-/mellomregningskonto',
  'bank.help.shareholderTitle': 'Uttak fra selskapet.',
  'bank.help.shareholderBody': 'Mellomregningen foreslås fordi den samler eierforholdet på én saldo. Er dette ikke tilbakebetaling av det selskapet skylder deg, blir det lån til aksjonær: asl. §8-7 stiller krav til dekning og sikkerhet, og sktl. §10-11 fjerde ledd beskatter det som utbytte hos deg. Utbytte og lønn skal bokføres i sine egne flyter.',
  'bank.help.invoicePayment': 'Bruk denne når bankinnbetalingen gjelder en eksisterende salgsfaktura. Bokføringen går mot kundefordringen og valgt bankkonto.',
  'bank.settlement.linked': 'Oppgjørsrapport koblet:',
  'bank.settlement.detail': 'faktura betales med {{gross}}, gebyr {{fee}} og netto bankinnbetaling {{payout}}.',
  'bank.help.noInvoiceMatch': 'Endre beløpet eller bruk Annet salg dersom innbetalingen ikke gjelder en faktura.',
  'bank.help.supplierPayment': 'Bruk denne når bankutbetalingen gjelder en leverandørfaktura som allerede er registrert. Betalingen føres mot leverandørgjelden og valgt bankkonto.',
  'bank.pickOpenSupplierInvoice': 'Velg åpen leverandørfaktura',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · gjenstår {{amount}}',
  'bank.overpayment': 'Overbetaling {{amount}}.',
  'bank.overpaymentHelp': 'Hele bankbeløpet registreres på leverandørfakturaen, og overskytende blir stående som tilgode hos leverandøren.',
  'bank.noSupplierInvoiceFits': 'Ingen åpne leverandørfakturaer passer beløpet.',
  'bank.noSupplierInvoiceFitsHelp': 'Ved overbetaling må restbeløpet matches mot fakturaen og overskytende føres separat.',
  'bank.help.taxPayment': 'Bruk denne bare for betalinger til Skatteetaten som ikke er en konkret MVA-termin eller forskuddstrekk/AGA.',
  'bank.selectedFeeAccount': 'valgt gebyrkonto',
  'bank.selectedRoundingAccount': 'valgt avrundingskonto',
  'bank.help.roundingWarning': 'Ørediff skal normalt være mindre enn 1 kr. Større avvik må forklares ved å kontrollere saldo og banklinjer.',
  'bank.help.free': 'Fri postering brukes for overføringer, gjeld, mellomregning, korreksjoner eller andre bankhendelser som ikke er vanlig kjøp, salg eller fakturabetaling.',
  'bank.help.newSupplierInvoice': 'Bruk denne når leverandørfakturaen ikke er registrert ennå. Banklinjen lagres med leverandørfaktura-detaljer slik at den kan kobles videre.',
  'bank.correction.requiredHint': 'Påkrevd. Lagres i revisjonssporet.',
  'bank.correction.reasonPh': 'Beskriv kort hvorfor posteringen korrigeres',
  'bank.noSeparateDoc.bank': 'Bankutskriften er dokumentasjon – eget bilag er ikke nødvendig',
  'bank.noSeparateDoc.other': 'Ingen separat dokumentasjon finnes eller er nødvendig',
  'bank.shortReasonPh': 'Kort begrunnelse',
  'bank.toast.pickFromInbox': 'Velg et bilag fra Innboks, ikke Dokumentasjon.',
  'bank.toast.linkedOnCorrection': 'Bilaget kobles når du lagrer korrigeringen.',
  'bank.toast.linkedToLine': 'Bilaget er koblet til banklinjen.',
  'bank.priv.filterAll': 'Alle',
  'bank.priv.filterOperating': 'Drift',
  'bank.priv.filterNew': 'Ikke behandlet',
  'bank.priv.filterIgnore': 'Ignorer',
  'bank.priv.statusIgnored': 'Ignorert',
  'bank.priv.noSafeMatches': 'Ingen sikre bilagsmatcher å koble ennå',
  'bank.priv.linkedN': 'Koblet {{count}} bilag mot private banklinjer',
  'bank.priv.pickOneLine': 'Velg minst én banklinje.',
  'bank.priv.ignoredN': '{{count}} linjer ignorert',
  'bank.priv.movedN': '{{count}} linjer flyttet til driften',
  'bank.priv.intro': 'Privat bank brukes som et ryddeverktøy: marker firmarelaterte linjer som Drift, og ignorer private eller irrelevante linjer. Det som markeres til driften, bokføres på driftskontoen.',
  'bank.priv.movedToOperating': 'Flyttet til driften',
  'bank.priv.noteTap': 'La SuperPlumma koble dem automatisk, eller trykk på et bilag og deretter på banklinjen.',
  'bank.priv.noteDrag': 'La SuperPlumma koble dem automatisk, eller dra et bilag rett på banklinjen.',
  'bank.toast.lineUpdated': 'Banklinje oppdatert',
  'bank.err.excelParserMissing': 'Excel-parseren er ikke lastet inn.',
  'bank.err.pdfParserMissing': 'PDF-parseren er ikke lastet inn.',
  'bank.toast.addBankAccountFirst': 'Legg til bankkonto i innstillinger først',
  'bank.err.archiveUnavailable': 'Arkivering av bankutskrift er ikke tilgjengelig ennå.',
  'bank.toast.privateReviewArchived': 'Privatgjennomgangen er fullført og arkivert',
  'bank.err.archiveFailed': 'Kunne ikke arkivere bankutskriften',
  'bank.err.reopenUnavailable': 'Gjenåpning av bankutskrift er ikke tilgjengelig ennå.',
  'bank.toast.statementReopened': 'Bankutskriften er åpnet igjen',
  'bank.err.reopenStatementFailed': 'Kunne ikke åpne bankutskriften igjen',
  'bank.account.private': 'Privatkonto',
  'bank.account.operating': 'Driftskonto',
  'bank.group.operating': 'Driftskontoer',
  'bank.group.private': 'Privatkontoer',
  'bank.group.doneReviews': 'Ferdig gjennomgåtte privatutskrifter',
  'bank.group.doneReconciled': 'Ferdig avstemte bankutskrifter',
  'bank.unknownPeriod': 'Ukjent periode',
  'bank.handledOf': '{{handled}} av {{lines}} håndtert',
  'bank.page.privateTitle': 'Privat bank',
  'bank.page.title': 'Bankavstemming',
  'bank.page.privateSubtitle': 'Rydd i privatkontoen - marker firmarelaterte linjer som drift og ignorer resten.',
  'bank.page.subtitle': 'Last inn XLSX, CSV, PDF eller et skjermbilde fra banken, marker firmalinjer som drift, og arkiver ferdige utskrifter.',
  'bank.tab.operating': 'Drift',
  'bank.tab.private': 'Privat',
  'bank.tab.archive': 'Arkiv',
  'bank.page.privateUploadHelp': 'Last opp privatutskriften her bare når du vil finne firmarelaterte utlegg. Den lagres på valgt foretak, men uten bankkonto fra Innstillinger.',
  'bank.noAccountRegistered': 'Ingen bankkonto registrert',
  'bank.stmt.reviewed': 'Gjennomgått',
  'bank.stmt.toReview': 'Til gjennomgang',
  'bank.stmt.toReconcile': 'Til avstemming',
  'bank.dropzone.uploadMore': 'Last opp flere bankutskrifter',
  'bank.dropzone.none': 'Ingen bankutskrifter ennå',
  'bank.dropzone.help': 'Dra inn en CSV-, PDF-, XLSX- eller bildefil fra banken, klikk for å velge, eller lim inn et skjermbilde med Ctrl+V. Vi matcher linjene mot bilagene dine automatisk.',
  'bank.connectHelp2': 'Hent transaksjoner automatisk og la SuperPlumma bokføre og avstemme regnskapet fortløpende - slipp manuell opplasting og bokføring.',
  'bank.toast.openBankingInfo': 'Sikker tilkobling til banken via Open Banking',
  'bank.guided.step1.title': 'Kontroller utskriften',
  'bank.guided.step1.sub': 'Sjekk periode og saldo',
  'bank.guided.step2.title': 'Godkjenn forslag',
  'bank.guided.step2.sub': 'Kontroller det Plumme har funnet',
  'bank.guided.step3.title': 'Behandle resten',
  'bank.guided.step3.sub': 'Velg hva betalingene gjelder',
  'bank.guided.step4.title': 'Koble bilag',
  'bank.guided.step4.sub': 'Dokumenter kjøpene',
  'bank.guided.step5.title': 'Fullfør',
  'bank.guided.step5.sub': 'Kontroller og arkiver',
  'bank.guided.stepOf': 'Steg {{step}} av {{total}}',
  'bank.guided.action.matched': 'Matchet mot allerede bokført',
  'bank.guided.action.fee': 'Bankgebyr',
  'bank.guided.action.invoice': 'Fakturabetaling',
  'bank.guided.action.purchase': 'Kjent kjøp',
  'bank.guided.action.sale': 'Registrer salg',
  'bank.guided.suggestionFromSuper': 'Forslag fra SuperPlumma',
  'bank.guided.receivables': 'Kundefordringer',
  'bank.guided.suggestedCostAccount': 'Foreslått kostnadskonto',
  'bank.guided.reason.sameAmount': 'Samme beløp og betalingsreferanse',
  'bank.guided.reason.textBased': 'Basert på tekst, beløp og tidligere bokføring',
  'bank.guided.suggestsAction': 'Plumme foreslår: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} MVA · Beløp {{amount}}',
  'bank.guided.voucherSuffix': ' · bilag: {{name}}',
  'bank.guided.out': 'UT',
  'bank.guided.in': 'INN',
  'bank.guided.moneyOut': 'PENGER UT',
  'bank.guided.moneyIn': 'PENGER INN',
  'bank.guided.unprocessedLine': '{{direction}} · Ikke behandlet',
  'bank.guided.bankPeriod': 'Bankperiode',
  'bank.guided.handledLeft': '{{handled}}/{{total}} behandlet · {{left}} igjen',
  'bank.guided.reopenNote': 'Åpner du avstemmingen igjen, låses perioden opp for kontroll. Bokførte linjer må korrigeres eller annulleres med revisjonsspor før de kan behandles på nytt.',
  'bank.guided.toast.enterClosing': 'Skriv inn sluttsaldoen fra bankutskriften.',
  'bank.guided.err.checkIndividually': 'Ett eller flere forslag må kontrolleres enkeltvis.',
  'bank.guided.toast.suggestionsDone': '{{count}} forslag er bokført og ferdige',
  'bank.guided.err.approveSuggestions': 'Kunne ikke godkjenne forslagene.',
  'bank.guided.toast.roundingPosted': 'Avrundingsforskjellen på {{amount}} er bokført',
  'bank.guided.err.roundingFailed': 'Kunne ikke bokføre avrundingsforskjellen.',
  'bank.guided.toast.markedNoVoucher': 'Kjøpet er merket uten bilag',
  'bank.guided.err.saveChoice': 'Kunne ikke lagre valget.',
  'bank.guided.err.voucherNotFound': 'Fant ikke bilaget i innboksen.',
  'bank.guided.err.linkFailed': 'Kunne ikke koble bilaget.',
  'bank.guided.toast.noSafeHits': 'Fant ingen sikre bilagstreff å koble.',
  'bank.guided.h.check': 'Stemmer perioden og saldoen?',
  'bank.guided.h.rest': 'Hva gjelder de resterende betalingene?',
  'bank.guided.p.check': 'Sjekk at dette er riktig kontoutskrift, og skriv inn saldoen som står ved slutten av perioden.',
  'bank.guided.p.rest': 'Velg hva hver betaling gjelder. Du trenger ikke kjenne kontonummer — Plumme hjelper deg med bokføringen.',
  'bank.guided.openingHint': 'Hentes normalt fra forrige ferdige avstemming.',
  'bank.guided.closingHint': 'Finn beløpet på kontoutskriften fra banken.',
  'bank.guided.closingMatches': 'Bankens sluttsaldo er lik det Plumme har beregnet.',
  'bank.guided.posting': 'Bokfører…',
  'bank.guided.postRounding': 'Før avrundingsforskjellen',
  'bank.guided.smallRounding': 'Lite avrundingsavvik på {{amount}}',
  'bank.guided.balanceDeviates': 'Saldoen avviker med {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Behandle betalingene i de neste stegene og kom tilbake dersom avviket består.',
  'bank.guided.canReturn': 'Du kan alltid komme tilbake til dette steget senere.',
  'bank.guided.correctToContinue': 'Korriger saldoene med blyantikonet for å gå videre.',
  'bank.guided.checkedContinue': 'Utskriften er kontrollert – fortsett',
  'bank.guided.superIntro': 'Noen linjer er matchet mot poster som allerede er bokført, andre har SuperPlumma foreslått bokføring for. Kontroller dem og trykk godkjenn — ingenting bokføres før du godkjenner.',
  'bank.guided.count.matched': 'matchet mot allerede bokført',
  'bank.guided.count.invoice': 'fakturabetalinger',
  'bank.guided.count.purchase': 'kjente kjøp',
  'bank.guided.count.fee': 'bankgebyr',
  'bank.guided.count.receipt': 'bilag funnet automatisk',
  'bank.guided.fixReading': 'Korriger avlesning fra PDF/CSV',
  'bank.guided.suggestionsPending': '{{count}} forslag er ikke godkjent ennå. Du kan godkjenne dem nå eller komme tilbake.',
  'bank.guided.allSuggestionsDone': 'Alle forslag er behandlet.',
  'bank.guided.tabHandling': 'Til behandling · {{count}}',
  'bank.guided.tabDeviation': 'Skaper avvik · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} bokførte poster skaper avvik',
  'bank.guided.linkHelp': 'Koble kvittering eller faktura til kjøpet. Hvis dokumentasjonen ikke finnes, velger du «Uten bilag» slik at valget lagres og kan kontrolleres senere.',
  'bank.guided.purchasesMissing': '{{count}} kjøp mangler bilag.',
  'bank.guided.noneMissing': 'Ingen bilag mangler.',
  'bank.guided.ctl.allHandled': 'Alle betalinger er behandlet',
  'bank.guided.ctl.remaining': '{{count}} gjenstår',
  'bank.guided.ctl.vouchersLinked': 'Nødvendige bilag er koblet',
  'bank.guided.ctl.missingVouchers': '{{count}} mangler bilag',
  'bank.guided.ctl.statementBalances': 'Bankutskriftens saldoer stemmer',
  'bank.guided.ctl.deviation': 'Avvik {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Bokført banksaldo stemmer',
  'bank.guided.ctl.clear': 'Klart',
  'bank.guided.finishNote': 'Når du fullfører, kontrollerer Plumme saldoene, låser perioden og flytter kontoutskriften til arkivet.',
  'bank.guided.allChecked': 'Alt er kontrollert og klart.',
  'bank.guided.resolveToFinish': 'Løs punktene over for å låse opp fullføring.',
  'bank.guided.toast.noPending': 'Ingen forslag venter på godkjenning.',
  'bank.guided.superLinks': 'SuperPlumma kobler',
  'bank.guided.approveSuggestions': 'Godkjenn forslagene',
  'bank.guided.note.tapPurchase': 'Trykk på et bilag, og deretter på kjøpet du vil koble det til.',
  'bank.guided.note.tapSuggestion': 'Trykk på et bilag, og deretter på forslaget. Mulig treff markeres i listen.',
  'bank.guided.note.dragPurchase': 'Dra et bilag over på kjøpet du vil koble det til.',
  'bank.guided.note.dragSuggestion': 'Dra et bilag over på et forslag. Mulig treff markeres i listen.',
  'bank.guided.err.checkImportFirst': 'Kontroller importovergangen først.',
  'bank.guided.toast.postingVoided': 'Posteringen er annullert',
  'bank.guided.archiving': 'Arkiverer…',
  'bank.guided.archiveNote': 'Kontrollen låses og flyttes til arkivet. Banklinjene er allerede bokført når de ble godkjent.',
  'bank.archive.lockedNote': 'Avstemmingen er låst. Utvid en linje for å se bilag og bokføring. Konto, MVA og intern beskrivelse kan korrigeres uten å endre bankbeløpet.',
  'bank.archive.searchPh': 'Søk i posteringer',
  'bank.archive.searchHelp': 'Søk på dato, beskrivelse, beløp, konto eller bilag.',
  'bank.archive.countOf': '{{shown}} av {{total}} posteringer',
  'bank.archive.handled': 'Behandlet',
  'bank.archive.code': 'Kode {{code}}',
  'bank.archive.auditTrail': 'Revisjonsspor',
  'bank.archive.correctionsOne': '{{count}} korrigering',
  'bank.archive.correctionsMany': '{{count}} korrigeringer',
  'bank.archive.noCorrections': 'Ingen korrigeringer',
  'bank.archive.internalDescription': 'Intern beskrivelse',
  'bank.archive.noVoucher': 'Ingen bilag koblet',
  'bank.archive.noMatch': 'Ingen posteringer matcher søket eller filtrene.',
  'bank.archive.err.correctFailed': 'Kunne ikke korrigere posteringen.',
  'bank.importFix.err.openFirst': 'Åpne koblingen eller posteringen før avlesningen korrigeres.',
  'bank.importFix.err.reasonLine': 'Skriv kort hvorfor banklinjen korrigeres.',
  'bank.importFix.err.amountNumber': 'Beløpet må være et tall.',
  'bank.importFix.removeFromRecon': 'Ignorer linje',
  'bank.importFix.warnTitle': 'Bruk kun hvis PDF/CSV er lest feil.',
  'bank.importFix.warnBody': 'Dette endrer ikke banken eller bokførte bilag. Originalverdiene beholdes i historikken.',
  'bank.importFix.blocked': 'Linjen er allerede koblet eller bokført. Åpne koblingen/posteringen før selve avlesningen korrigeres.',
  'bank.importFix.originalRead': 'Originalt avlest',
  'bank.importFix.effect': 'Effekt på avstemming',
  'bank.importFix.deviationNow': 'Avvik nå:',
  'bank.importFix.afterCorrection': 'Etter korrigering:',
  'bank.importFix.stillDeviates': 'Hvis avviket fortsatt står igjen, kontroller om IB/UB også er lest feil.',
  'bank.importFix.fixLine': 'Rett linjen',
  'bank.importFix.removeMisread': 'Ignorer linje', 'bank.ignoreLine': 'Ignorer linje', 'bank.ignoreLineHelp': 'Bruk dette bare når linjen er feilavlest og ikke finnes i bankutskriften. Linjen beholdes i historikken.', 'bank.ignoreLineConfirm': 'Ignorer linjen', 'bank.ignoreLineReason': 'Hvorfor ignoreres linjen?', 'bank.ignoreLineReasonHint': 'Kreves for revisjonssporet.', 'bank.ignoreLineReasonPlaceholder': 'F.eks. linjen finnes ikke i bankutskriften',
  'bank.importFix.removeNote': 'Linjen blir liggende i historikken, men teller som 0,00 kr og regnes som ferdig i avstemmingen. Brukes bare når linjen ikke finnes i bankutskriften.',
  'bank.importFix.whyReading': 'Hvorfor korrigeres avlesningen?',
  'bank.importFix.whyReadingPh': 'F.eks. OCR leste feil beløp / linjen finnes ikke i bankutskriften',
  'bank.importFix.err.balancesNumber': 'IB og UB må være tall.',
  'bank.importFix.err.reasonBalance': 'Skriv kort hvorfor saldoen korrigeres.',
  'bank.importFix.saveBalance': 'Lagre saldo',
  'bank.importFix.balanceWarnTitle': 'Endre kun hvis saldoen fra utskriften/importen er feil.',
  'bank.importFix.balanceWarnBody': 'IB hentes normalt fra forrige avstemte UB. Original avlest saldo beholdes.',
  'bank.importFix.resultPrefix': 'Med dagens behandlede banklinjer blir saldoavviket',
  'bank.importFix.whyBalance': 'Hvorfor korrigeres saldoen?',
  'bank.importFix.whyBalancePh': 'F.eks. UB ble lest fra feil rad i PDF-en',
  'bank.loan.intro': 'Bruk dette for låneopptak, avdrag eller betalinger som kan splittes i avdrag, renter og gebyr. Valgt konto hentes fra foretakets aktive kontoplan, og føringen gjøres uten MVA.',
  'bank.loan.account': 'Låne-/gjeldskonto',
  'bank.loan.noAccount': 'Fant ingen vanlig låne-/gjeldskonto i den aktive kontoplanen. Opprett riktig konto eller bruk fri postering.',
  'bank.loan.principal': 'Avdrag / lånebeløp',
  'bank.loan.splitMismatch': 'Splitten må stemme med bankbeløpet. Gjenstår: {{amount}} kr.',
  'bank.loan.docLinked': 'Dokumentasjon er koblet.',
  'bank.loan.docRemember': 'Husk dokumentasjonen.',
  'bank.loan.docHelp': 'Last opp låneavtale, nedbetalingsplan eller annet underlag. Splitten må kunne dokumenteres.',
  'bank.loan.complex': 'Gjelder linjen nærstående, uvanlig konto eller mer komplisert låneforhold?',
  'bank.loan.useFree': 'Bruk fri postering',
  'bank.group.err.sameDirection': 'Alle banklinjene i en fordelingsgruppe må ha samme retning.',
  'bank.group.err.pickBoth': 'Velg begge banklinjene i overføringen.',
  'bank.group.toast.transferApproved': 'Overføringen er godkjent og bokført samlet.',
  'bank.group.toast.allocationApproved': 'Fordelingen er godkjent og bokført samlet.',
  'bank.group.err.approveFailed': 'Kunne ikke godkjenne matchinggruppen.',
  'bank.group.title': 'Match flere bankhendelser',
  'bank.group.approve': 'Godkjenn og bokfør gruppe',
  'bank.group.oneOperation': 'Én kontrollert operasjon',
  'bank.group.oneOperationHelp': 'Gruppen reserverer alle valgte banklinjer. Bokføring og kobling skjer samlet i backend når du godkjenner.',
  'bank.group.matchType': 'Type matching',
  'bank.group.typeAllocation': 'Fordel betaling mot åpne poster',
  'bank.group.typeTransfer': 'Intern overføring mellom egne kontoer',
  'bank.group.sourceLine': 'Linje fra én konto',
  'bank.group.counterLine': 'Motpost på egen konto',
  'bank.group.pickOpposite': 'Velg motsatt banklinje',
  'bank.group.transferRules': 'Bare samme dato og beløp, motsatt fortegn og en annen konfigurert bankkonto tilbys. Ulike datoer krever transittkonto.',
  'bank.group.noOpenItems': 'Ingen åpne {{kind}} kan allokeres.',
  'bank.group.customerInvoices': 'kundefakturaer',
  'bank.group.supplierInvoices': 'leverandørfakturaer',
  'bank.group.itemRest': '{{number}} · {{party}} · rest {{amount}}',
  'bank.group.removeRow': 'Fjern rad',
  'bank.corr.err.reasonVoid': 'Skriv kort hvorfor posteringen annulleres.',
  'bank.corr.err.notFieldCorrectable': 'Denne posttypen kan ikke feltkorrigeres fra bankavstemmingen. Annuller posteringen og før den riktig på nytt, eller åpne bilaget i bilagsjournalen.',
  'bank.corr.err.supplierPaymentVoid': 'Betalinger av leverandørfaktura annulleres fra leverandørbilaget.',
  'bank.corr.err.noSupportedAction': 'Fant ikke en støttet handling for denne bokførte posten.',
  'bank.receipt.toast.trashed': 'Bilaget er flyttet til papirkurven.',
  'bank.receipt.err.deleteFailed': 'Kunne ikke slette bilaget.',
  'bank.receipt.deleting': 'Sletter…',
  'bank.receipt.delete': 'Slett bilag',
  'bank.mode.toFull': 'Bytt til full oversikt',
  'bank.mode.toGuided': 'Bytt til steg for steg',
  'bank.import.toast.privateSaved': 'Privatutskrift lagret - klar for gjennomgang',
  'bank.import.toast.saved': 'Bankutskrift lagret - klar for avstemming',
  'bank.inbox.view.statement': 'Denne utskriften',
  'bank.inbox.view.unlinked': 'Bare ikke koblet',
  'bank.inbox.view.all': 'Alle bilag',
  'bank.inbox.showInList': 'Vis i innboksen',
  'bank.inbox.viewing': 'Viser: {{view}} · {{hidden}} skjult',
  'bank.inbox.waiting': '{{count}} bilag venter på arbeid',
  'bank.inbox.hide': 'Skjul innboks',
  'bank.inbox.companyAddress': 'bilagsinnboksen for foretaket',
  'bank.inbox.defaultNote': 'Dra et bilag over på en banklinje, eller la SuperPlumma foreslå treff.',
  'bank.inbox.uploadVoucher': 'Last opp bilag',
  'bank.inbox.orDrag': 'Eller dra · slipp på en linje som mangler bilag',
  'bank.inbox.dropHint': 'Slipp filer her for å laste opp nye bilag.',
  'bank.inbox.noMatch': 'Ingen bilag matcher søket.',
  'bank.inbox.noneInSelection': 'Ingen bilag i dette utvalget · {{hidden}} skjult av filteret',
  'bank.inbox.allDone': 'Alle bilag er ferdig behandlet',
  'bank.inbox.empty': 'Innboksen er tom',
  'bank.inbox.tip.showAll': 'Trykk for å vise alle banklinjene igjen',
  'bank.inbox.tip.showLine': 'Trykk for å vise banklinjen dette bilaget er koblet til',
  'bank.inbox.tip.linkedElsewhere': 'Koblet utenfor denne bankutskriften',
  'bank.inbox.linkedHere': 'Koblet · {{label}}',
  'bank.inbox.linkedIn': 'Koblet i {{label}}',
  'bank.inbox.previewName': 'Forhåndsvis {{name}}',
  'bank.inbox.voucherLower': 'bilag',
  'bank.inbox.filteredOne': 'Filtrert på ett bilag',
  'bank.inbox.filteredN': 'Filtrert på {{count}} bilag',
  'bank.inbox.filterShowsLinked': 'Viser bare banklinjene bilagene er koblet til',
  'bank.inbox.showAllLines': 'Vis alle linjer',
  'bank.inbox.nBankLines': '{{count}} banklinjer',
  'bank.inbox.bankLineLower': 'banklinje',
  'bank.inbox.anotherStatement': 'en annen bankutskrift',
  'bank.inbox.toast.linkedElsewhere': 'Bilaget er koblet til en banklinje i {{label}}.',
  'bank.resolve.annulText': 'Posten er dobbeltført. Reverser den så den ikke teller med. Et eventuelt bilag legges automatisk tilbake i innboksen.',
  'bank.resolve.correctText': 'Bokføringen skal være der, men konto, MVA eller intern beskrivelse er feil. Bankbeløp og dato forblir låst.',
  'bank.resolve.err.voidFailed': 'Kunne ikke annullere den bokførte posten.',
  'bank.resolve.voiding': 'Annullerer…',
  'bank.resolve.confirmVoid': 'Bekreft annullering',
  'bank.resolve.voidReason': 'Årsak til annullering',
  'bank.resolve.voidReasonHint': 'Påkrevd. Begrunnelsen lagres i revisjonssporet.',
  'bank.resolve.voidReasonPh': 'Beskriv kort hvorfor posteringen skal annulleres',
  'bank.resolve.row.postedEntry': 'Bokført post',
  'bank.resolve.row.account': 'Konto',
  'bank.resolve.row.vat': 'MVA',
  'bank.resolve.row.amount': 'Beløp',
  'bank.resolve.row.lineDate': 'Dato på banklinjen',
  'bank.resolve.row.bankLine': 'Banklinje',
  'bank.resolve.row.voucher': 'Bilag',
  'bank.resolve.row.notLinked': 'Ikke koblet',
  'bank.resolve.reopenAsDeviation': 'Åpne som avvik',
  'bank.resolve.releaseInvestmentMatch': 'Frigjør bankkobling',
  'bank.resolve.reverse': 'Reverser',
  'bank.resolve.alreadyPosted': 'Denne banklinjen er allerede bokført eller matchet. Den kan derfor ikke behandles som en ny linje.',
  'bank.resolve.useCorrection': 'Bruk korrigering for konto, MVA eller intern beskrivelse. Bankbeløp, dato og kobling forblir låst.',
  'bank.resolve.reverseInfo': 'Reversering annullerer kjøpet med spor og åpner banklinjen for ny kontroll.',
  'bank.resolve.existingInfo': 'Dette er koblet til et eksisterende bilag eller en eksisterende post. Korriger selve bilaget hvis grunnlaget er feil.',
  'bank.resolve.verifiableInfo': 'Denne koblingen kan etterprøves fra postdetaljene.',
  'bank.resolve.approving': 'Godkjenner…',
  'bank.resolve.approveN': 'Godkjenn {{count}} forslag',
  'bank.resolve.confirmIntro': 'Kontroller oppsummeringen. Forslag som er matchet mot en eksisterende post lager ikke ny bokføring.',
  'bank.resolve.voucherReturns': 'Bilaget «{{name}}» legges automatisk tilbake i innboksen når posten annulleres.',
  'bank.err.uploadVoucherFailed': 'Kunne ikke laste opp bilaget.',
  'bank.drop.attachAsDoc': 'Legges ved som dokumentasjon',
  'bank.drop.uploadAnalyzeLink': 'Lastes opp, analyseres og kobles',
  'bank.receipt.confirmDelete': 'Slette bilaget fra innboksen? Det flyttes til papirkurven og kan gjenopprettes.',
  'bank.percentDone': '{{pct}}% fullført',
  // My page (minside)
  'mypage.role.owner': 'Eier',
  'mypage.role.admin': 'Administrator',
  'mypage.role.accountant': 'Regnskapsfører',
  'mypage.role.viewer': 'Leser',
  'mypage.shortcut.oversikt.title': 'Oversikt',
  'mypage.shortcut.oversikt.text': 'Helsescore og økonomisk oversikt for husholdningen',
  'mypage.shortcut.forbruk.title': 'Forbruk',
  'mypage.shortcut.forbruk.text': 'Hva pengene går til, fordelt på kategorier',
  'mypage.shortcut.familie.title': 'Familie',
  'mypage.shortcut.familie.text': 'Felles budsjett og fordeling i husholdningen',
  'mypage.shortcut.fremtid.title': 'Fremtid',
  'mypage.shortcut.fremtid.text': 'Sparing, lån, pensjon og fremtidsplaner',
  'mypage.shortcut.skatt.title': 'Skatt',
  'mypage.shortcut.skatt.text': 'Privat skattemelding, fradrag og estimat',
  'mypage.fallback.business': 'Foretak',
  'mypage.fallback.signedInUser': 'Innlogget bruker',
  'mypage.fallback.employerLoadError': 'Kunne ikke hente arbeidsgivere.',
  'mypage.verify.body': 'Noen funksjoner, blant annet klientinvitasjoner og ansattportalen, krever at {{email}} er bekreftet. Send lenken på nytt hvis du ikke finner den, åpne lenken i e-posten og trykk deretter på at du har bekreftet.',
  'mypage.verify.resend': 'Send bekreftelse på nytt',
  'mypage.verify.sending': 'Sender...',
  'mypage.verify.confirmed': 'Jeg har bekreftet',
  'mypage.verify.checking': 'Sjekker...',
  'mypage.err.profileNotConnected': 'Profil-lagring er ikke koblet til backend.',
  'mypage.toast.profileUpdated': 'Profilen er oppdatert',
  'mypage.err.profileUpdateFailed': 'Kunne ikke oppdatere profilen.',
  'mypage.err.verifyNotConnected': 'E-postbekreftelse er ikke koblet til backend.',
  'mypage.toast.alreadyVerified': 'E-postadressen er allerede bekreftet.',
  'mypage.toast.verifyResent': 'Bekreftelseslenke er sendt på nytt.',
  'mypage.err.verifySendFailed': 'Kunne ikke sende bekreftelseslenke.',
  'mypage.err.verifyStatusFailed': 'Kunne ikke sjekke e-poststatus.',
  'mypage.toast.emailVerified': 'E-postadressen er bekreftet.',
  'mypage.toast.stillUnverified': 'Adressen er fortsatt ikke bekreftet. Sjekk innboksen og prøv igjen.',
  'mypage.err.personalNotConnected': 'Privatøkonomi er ikke koblet til backend i denne builden.',
  'mypage.toast.personalCreated': 'Privatøkonomi er opprettet',
  'mypage.err.personalCreateFailed': 'Kunne ikke opprette privatøkonomi.',
  'mypage.toast.openPersonalForFamily': 'Åpne Privatøkonomi for å endre Familie.',
  'mypage.toast.familyEnabled': 'Familie er aktivert.',
  'mypage.toast.familyDisabled': 'Familie er deaktivert.',
  'mypage.err.familySaveFailed': 'Kunne ikke lagre Familie-innstilling.',
  'mypage.titleHelp': 'Min side er din personlige konto i Plumme — atskilt fra selve regnskapene. Her ser du profilen din, virksomhetene du har tilgang til, arbeidsgiverne du er ansatt hos, og inngangen til privatøkonomien din.',
  'mypage.field.memberSince': 'Medlem siden',
  'mypage.toast.onboardingNotLoaded': 'Onboarding er ikke lastet ennå.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Henter virksomheter',
  'mypage.biz.loadingText': 'Kobler til Plumme backend.',
  'mypage.biz.emptyTitle': 'Ingen egne foretak',
  'mypage.biz.emptyText': 'Du kan opprette et foretak her senere, også om du bare bruker Plumme som regnskapsfører eller privatbruker.',
  'mypage.clients.title': 'Klientoppdrag',
  'mypage.clients.help': 'Foretak der du er invitert som regnskapsfører, administrator eller leser. Klientdata holdes adskilt fra egne foretak og Privatøkonomi.',
  'mypage.clients.setup': 'Regnskapsføreroppsett',
  'mypage.clients.access': 'Klienttilgang',
  'mypage.clients.empty': 'Du har ingen aktive klientoppdrag. Invitasjoner vises globalt etter innlogging.',
  'mypage.pf.creating': 'Oppretter...',
  'mypage.pf.create': 'Opprett privatøkonomi',
  'mypage.pf.intro': 'Din personlige rådgiver for husholdningsøkonomien - holdt adskilt fra virksomhetenes regnskap. Velg en oversikt for å komme i gang.',
  'mypage.pf.family': 'Familie',
  'mypage.pf.familyText': 'Vis Familie-siden i Privatøkonomi.',
  'mypage.pf.emptyIntro': 'Opprett en privatøkonomi-klient for å samle privat oversikt, import, husholdning, skatt og rapporter uten å blande det med regnskapsklientene.',
  'mypage.emp.fallbackRole': 'Ansatt',
  'mypage.emp.loadingTitle': 'Henter arbeidsgivere',
  'mypage.emp.emptyTitle': 'Ingen arbeidsgivere',
  'mypage.emp.loadingText': 'Kobler til ansattportal.',
  'mypage.emp.emptyText': 'Ingen ansattportal-tilganger er registrert for brukeren.',
  'mypage.err.passwordResetNotConnected': 'Passord-tilbakestilling er ikke koblet til backend.',
  'mypage.toast.passwordLinkSent': 'Lenke for å endre passord er sendt på e-post',
  'mypage.err.passwordLinkFailed': 'Kunne ikke sende passordlenke.',
  'mypage.saving': 'Lagrer...',
  'mypage.hh.loadError': 'Kunne ikke hente husholdningskoblingen.',
  'mypage.hh.updateError': 'Kunne ikke oppdatere husholdningen.',
  'mypage.hh.inviteEmailFailed': 'Invitasjonen er opprettet, men e-posten kunne ikke sendes. Du kan prøve igjen.',
  'mypage.hh.inviteSent': 'Invitasjonen er opprettet og sendt.',
  'mypage.hh.left': 'Husholdningskoblingen er avsluttet.',
  'mypage.hh.hiddenPending': 'Invitasjonen er trukket tilbake og fjernet fra listen.',
  'mypage.hh.hidden': 'Invitasjonen er fjernet fra listen.',
  'mypage.hh.loading': 'Henter husholdningsstatus …',
  'mypage.hh.partnerFallback': 'Tilkoblet partner',
  'mypage.hh.twoAccounts': 'To separate kontoer · delt Familie-side',
  'mypage.hh.leaveConfirm': 'Koble fra husholdningen? Begge beholder egne data, mens den delte Familie-profilen avsluttes.',
  'mypage.hh.leaving': 'Kobler fra …',
  'mypage.hh.leave': 'Koble fra husholdningen',
  'mypage.hh.inviteIntro': 'Inviter en partner med e-post. Mottakeren kan logge inn eller opprette en ny Plumme-konto, og får hjelp til å opprette Privatøkonomi før koblingen godkjennes.',
  'mypage.hh.inviting': 'Oppretter …',
  'mypage.hh.invite': 'Inviter partner',
  'mypage.hh.userFallback': 'Plumme-bruker',
  'mypage.hh.joined': 'Husholdningen er koblet sammen.',
  'mypage.hh.sentInvites': 'Sendte invitasjoner',
  'mypage.hh.resendFailedToast': 'Invitasjonen er aktiv, men e-posten kunne ikke sendes.',
  'mypage.hh.resentToast': 'Invitasjonen er sendt på nytt.',
  'mypage.hh.resend': 'Send på nytt',
  'mypage.hh.remind': 'Påminn',
  'mypage.hh.withdrawn': 'Invitasjonen er trukket tilbake.',
  'mypage.hh.removeFromList': 'Fjern fra listen',
  'mypage.hh.status.pending': 'Venter på svar · {{delivery}}',
  'mypage.hh.status.expired': 'Utløpt',
  'mypage.hh.status.declined': 'Avslått',
  'mypage.hh.status.canceled': 'Trukket tilbake',
  'mypage.hh.status.accepted': 'Godtatt',
  'mypage.hh.delivery.delivered': 'e-post levert',
  'mypage.hh.delivery.opened': 'e-post åpnet',
  'mypage.hh.delivery.clicked': 'lenke åpnet',
  'mypage.hh.delivery.failed': 'e-post feilet',
  'mypage.hh.delivery.bounced': 'e-post avvist',
  'mypage.hh.delivery.complained': 'merket som søppelpost',
  'mypage.hh.delivery.delivery_delayed': 'e-post forsinket',
  'mypage.hh.delivery.sent': 'e-post sendt',
  // Activity log (aktivitetslogg)
  'audit.domain.settings': 'Innstillinger',
  'audit.domain.invoices': 'Faktura',
  'audit.domain.sales': 'Salg',
  'audit.domain.expenses': 'Kjøp',
  'audit.domain.customers': 'Kunder',
  'audit.domain.products': 'Produkter',
  'audit.domain.suppliers': 'Leverandører',
  'audit.domain.inbox': 'Innboks',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Kjørebok',
  'audit.domain.payroll': 'Lønn',
  'audit.domain.business': 'Foretak',
  'audit.domain.access': 'Tilganger',
  'audit.summary.rows': '{{count}} rader',
  'audit.summary.fields': '{{count}} felt',
  'audit.event.updated': 'Oppdaterte {{domains}}',
  'audit.event.updatedBusinessData': 'Oppdaterte foretakets data',
  'audit.event.businessCreated': 'Opprettet foretaket',
  'audit.event.inviteCreated': 'Inviterte {{email}} som {{role}}',
  'audit.event.inviteAccepted': '{{user}} godtok invitasjonen',
  'audit.event.deletionRequestedFor': 'Ba om sletting av foretaket {{date}}',
  'audit.event.deletionRequested': 'Ba om sletting av foretaket',
  'audit.event.deletionCanceled': 'Kansellerte sletting av foretaket',
  'audit.fallback.newUser': 'ny bruker',
  'audit.fallback.userLower': 'bruker',
  'audit.fallback.user': 'Bruker',
  'audit.fallback.unknownUser': 'Ukjent bruker',
  'audit.err.loadFailed': 'Kunne ikke hente aktivitetslogg.',
  'audit.meta.time': 'Tidspunkt',
  'audit.meta.user': 'Bruker',
  'audit.meta.role': 'Rolle',
  'audit.meta.action': 'Handling',
  'audit.meta.source': 'Kilde',
  'audit.meta.invite': 'Invitasjon',
  'audit.meta.targetUser': 'Målbruker',
  'audit.detail.before': 'Før:',
  'audit.detail.after': 'Etter:',
  'audit.titleHelp': 'Aktivitetsloggen er en revisjonslogg: den viser alle viktige handlinger som er gjort i regnskapet - hvem som gjorde hva, når, og på hvilket område. Nyttig for sporbarhet og kontroll når flere samarbeider.',
  'audit.search': 'Søk i aktivitetslogg for {{year}}',
  'audit.scope.all': 'Alle',
  'audit.scope.others': 'Andre',
  'audit.scope.mine': 'Meg',
  'audit.scope.access': 'Tilganger',
  'audit.col.event': 'Hendelse',
  'audit.empty.loadingTitle': 'Henter aktivitetslogg',
  'audit.empty.loadingText': 'Kobler til Plumme backend.',
  'audit.empty.noMatchTitle': 'Ingen treff',
  'audit.empty.noMatchText': 'Ingen aktiviteter passer filteret. Prøv å nullstille det.',
});
